import { SET_LOGGED_IN, SET_USER_INFO, SET_LOGO_NON_LOGIN, SET_CUSTOMER_PORTAL, SET_SHOW_ROUTE } from "./user.constant";

/* Actions */
import { setLoggedIn, setLogoNonLogin, setUserInfo, setCustomerPortal, setIsShowRoute } from "./user.action";

const initialState: UserState = { isLoggedIn: false, userInfo: {}, logos: {}, customerPortal: false, isShowRoute: true };

type UserAction = ReturnType<typeof setLoggedIn | typeof setUserInfo | typeof setLogoNonLogin | typeof setCustomerPortal | typeof setIsShowRoute>;

export function userReducer(state = initialState, action: UserAction): UserState {
  switch (action.type) {
    case SET_LOGGED_IN:
      return { ...state, isLoggedIn: action.payload };
    case SET_USER_INFO:
      return { ...state, userInfo: action.payload };
    case SET_LOGO_NON_LOGIN:
      return { ...state, logos: action.payload };
    case SET_CUSTOMER_PORTAL:
      return { ...state, customerPortal: action.payload };
    case SET_SHOW_ROUTE:
      return { ...state, isShowRoute: action.payload };
    default:
      return state;
  }
}
